import React from 'react';

export interface IConfigurationItemProps {
    className: string;
    label: string;
    isChecked: boolean;
    onToggle: () => void;
}

export const ConfigurationItem: React.FC<IConfigurationItemProps> = ({ className, label, isChecked, onToggle }) => {
    return (
        <label className={`${className}__field-item`}>
            <input type='checkbox' checked={isChecked} onChange={onToggle} />
            <span className={`${className}__field-label`}>{label}</span>
        </label>
    );
};
